import React, { type FC } from 'react';
import { SkeletonLine } from '@wix/wix-ui-tpa/cssVars';
import { st, classes } from './Skeleton.st.css';

interface SkeletonProps {
  isLine?: boolean;
  className?: string;
}

export const Skeleton: FC<SkeletonProps> = ({ isLine = false, className }) => (
  <SkeletonLine className={st(classes.root, { isLine }, className)} />
);
